module.exports = __webpack_public_path__ + "files/8a4193f2848d39e2635335818e209de3.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/video.png
// module id = 314
// module chunks = 60